var scope_0 = require('F:/web/active/infoamazonia-mercurio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0688f7fc8ebdde9ac730154e30219235.js').default;
var scope_1 = require('F:/web/active/infoamazonia-mercurio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5eba3b3fe8b6232fb92aaa61a45a8f42.js').default;
var scope_2 = require('F:/web/active/infoamazonia-mercurio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/79a444f4de02421497b112d6daff5b4d.js').default;
var scope_3 = require('F:/web/active/infoamazonia-mercurio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7d1df1f13e3e7cfc0146ebe6854edeb7.js').default;
var scope_4 = require('F:/web/active/infoamazonia-mercurio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a6f5e0d921cddc3e6233923118d8f894.js').default;
var scope_5 = require('F:/web/active/infoamazonia-mercurio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf0d37c3deb28d0a80012cc83037797a.js').default;
var scope_6 = require('F:/web/active/infoamazonia-mercurio/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fb8ea0205c12df83f06bf01dc7df2e4d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    